module.exports = __webpack_public_path__ + "img/technology9.9391148b.png";